// src/redux/slices/reservationAgentReportSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ReservationAgentProduReport } from "../../Services/Service";

// ✅ THUNK (API CALL)
export const fetchAgentReport = createAsyncThunk(
    "agentReport/fetchAgentReport",
    async (params, { rejectWithValue }) => {
        try {
            const response = await ReservationAgentProduReport(params);
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// ✅ SLICE
const reservationAgentReportSlice = createSlice({
    name: "agentReport",
    initialState: {
        Agentloading: false,
        data: [],
        error: null,
    },
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchAgentReport.pending, (state) => {
                state.Agentloading = true;
            })
            .addCase(fetchAgentReport.fulfilled, (state, action) => {
                state.Agentloading = false;
                state.data = action.payload;
            })
            .addCase(fetchAgentReport.rejected, (state, action) => {
                state.Agentloading = false;
                state.error = action.payload;
            });
    },
});

export default reservationAgentReportSlice.reducer;